angular.module('NumbersEditor')
    .controller('HomeController', [
        '$scope', 'HomeFactory', '$location', '$rootScope', 'PublishGameFactory', '$dialogs', 'gameService', 'appInfoFactory', 'authFactory', '$route',
        function ($scope, homeFactory, $location, $rootScope, publishGameFactory, $dialogs, gameService, appInfoFactory, authFactory, $route) {

            init();

            $scope.LoadingUpcomingGames = false;

            function init() {
                $rootScope.SetAppTitle("Home", "Today's Games");
                $scope.isTechSuper = authFactory.GetAuthenticationData().isTechSuper;
                appInfoFactory.getDateTime()
                    .success(function (today) {
                        $scope.Today = new Date(JSON.parse(today));
                        getTodaysGames();
                    }).error(function (err) {
                        logError(err);
                    });
                appInfoFactory.getApplicationInfo()
                    .success(function (appInfo) {
                        $scope.Environment = appInfo.Environment;
                        $scope.AllGameMode = appInfo.AllGameMode;
                    }).error(function (err) {
                        logError(err);
                    });
                setMinMaxDates();
            }

            function setMinMaxDates() {
                var minDate = new Date();
                var maxDate = new Date();
                var maxDate = new Date(maxDate.setMonth(maxDate.getMonth() + 3));
                $scope.fromMinDate = new Date(minDate.setDate(minDate.getDate() + 1));
                $scope.fromMaxDate = new Date(maxDate.setDate(maxDate.getDate() - 1));
                $scope.toMinDate = $scope.fromMinDate;
                $scope.toMaxDate = $scope.fromMaxDate;
            }

            function getTodaysGames() {
                var homeFilterData = getHomeFilterData();
                homeFactory.getTodaysGames(homeFilterData.FromDate, homeFilterData.ToDate)
                    .success(function (games) {
                        var todaysGame = Enumerable.From(games)
                            .Where(function (x) {
                                var jsDate = new Date(x.StartDate);
                                var today = $scope.Today;
                                return jsDate.getFullYear() + "/" + (jsDate.getMonth() + 1) + "/" + jsDate.getDate() === today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate();
                            })
                            .ToArray();
                        $scope.Games = todaysGame;
                        var upcomingGames = Enumerable.From(games)
                            .Where(function (x) {
                                var jsDate = new Date(x.StartDate);
                                var today = $scope.Today;
                                return jsDate.getFullYear() + "/" + (jsDate.getMonth() + 1) + "/" + jsDate.getDate() !== today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate();
                            })
                            .ToArray();

                        upcomingGames.FromDate = homeFilterData.FromDate;
                        upcomingGames.ToDate = homeFilterData.ToDate;
                        $scope.UpcomingGames = upcomingGames;
                        gameService.setDatePicker($scope);
                        $scope.LoadingUpcomingGames = false;
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            function getHomeFilterData() {
                var filterData = localStorage.getItem("homeFilterData");
                if (filterData === null) {
                    var minDate = new Date();
                    var maxDate = new Date();
                    filterData = setHomeFilterData(
                        new Date(minDate.setDate(minDate.getDate() + 1)),
                        new Date(maxDate.setDate(maxDate.getDate() + 7))
                    );
                } else {
                    filterData = JSON.parse(filterData)
                }
                return filterData;
            }

            function setHomeFilterData(fromDate, toDate) {
                if (fromDate !== undefined && toDate !== undefined) {
                    var filterData = {
                        FromDate: fromDate.toISOString(),
                        ToDate: toDate.toISOString()
                    };
                    localStorage.setItem("homeFilterData", JSON.stringify(filterData));
                    return filterData;
                }
            }

            $scope.deleteGame = function (game, $event) {
                $event.stopPropagation();
                $dialogs.confirm('Please Confirm', 'Are you sure you want to delete this game?').result.then(function () {
                    gameService.deleteGame(game).success(function () {
                        $route.reload();
                    }).error(function (err) {
                        logError(err);
                    });
                });
            }

            $scope.canDelete = function (game) {
                if (!$scope.AllGameMode || game.Status === "I") return false;
                return true;
            }

            $scope.go = function (view, id, sportCode, startDate) {
                $location.path(view + '/' + id).search({ sportCode: sportCode, startDate: startDate });
            };

            $scope.SaveAndPublish = function (game) {
                gameService.getGame(game.Id, game.SportCode, game.StartDate).then(function (getGame) {
                    gameService.saveGame(getGame).success(function (id) {
                        gameService.publishGame(id).success(function (data) {
                            $.message(MessageText.GameSuccessfullyPublished, MessageType.Success);
                            game.PublicationStamp = data.PublicationStamp;
                            game.Id = id;
                        })
                            .error(function (error) {
                                logError(error);
                            });
                    })
                        .error(function (error) {
                            logError(error);
                        });
                })
                    .catch(function (error) {
                        logError(error);
                    });
            };

            $scope.Publish = function (game) {
                gameService.getGame(game.Id, game.SportCode, game.StartDate).then(function (getGame) {
                    gameService.publishGame(game.Id).success(function (data) {
                        $.message(MessageText.GameSuccessfullyPublished, MessageType.Success);
                        game.PublicationStamp = data.PublicationStamp;
                    })
                        .error(function (error) {
                            logError(error);
                        });
                }).catch(function (error) {
                    logError(error);
                });
            };


            function logError(error) {
                $.message(error.ExceptionMessage, MessageType.Error);
            }

            $scope.PublishGame = function (game) {
                var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to publish this game?');
                dlg.result.then(function (btn) {
                    publishGameFactory.PublishGame(game.Id)
                        .success(function (data) {
                            $.message(MessageText.GameSuccessfullyPublished, MessageType.Success);
                            game.PublicationStamp = data.PublicationStamp;
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                });
            };
            $scope.CanPublishGame = function (game) {
                if (game.HasCompleted == true && game.PublicationStamp == null) {
                    return true;
                }
                return false;
            };

            $scope.$watch('UpcomingGames.FromDate', function () {
                $scope.fromOpened = false;
                if ($scope.UpcomingGames !== undefined) {
                    $scope.toMinDate = new Date($scope.UpcomingGames.FromDate);
                }
            });

            $scope.$watch('UpcomingGames.ToDate', function () {
                $scope.toOpened = false;
                if ($scope.UpcomingGames !== undefined) {
                    $scope.fromMaxDate = new Date($scope.UpcomingGames.ToDate);
                }
            });

            $scope.FilterUpcoming = function () {
                setHomeFilterData(new Date($scope.UpcomingGames.FromDate), new Date($scope.UpcomingGames.ToDate));
                $scope.LoadingUpcomingGames = true;
                getTodaysGames();
            }

            $scope.closemodals = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.fromOpened = false;
                $scope.toOpened = false;
            };

            $scope.fromOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.fromOpened = true;
                $scope.toOpened = false;
            };

            $scope.toOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.toOpened = true;
                $scope.fromOpened = false;
            };
        }
    ]);